var map = {
	"./MOTOS.png": 926,
	"./about-us-icon.svg": 927,
	"./about/aboutBG.jpg": 928,
	"./about/abtres.png": 929,
	"./about/abtres.svg": 930,
	"./about/building.jpg": 931,
	"./about/download.png": 932,
	"./about/download.svg": 933,
	"./about/focusbtn.svg": 934,
	"./about/headingImage.png": 935,
	"./about/investment.png": 936,
	"./about/investment2.png": 937,
	"./about/overview1.png": 938,
	"./about/people.svg": 939,
	"./about/ra-profile.jpg": 940,
	"./about/star.svg": 941,
	"./about/trust.png": 942,
	"./account/accountBG.svg": 943,
	"./account/accountstatement.svg": 944,
	"./account/captcha.svg": 945,
	"./account/greenRight.svg": 946,
	"./arrowleft.png": 947,
	"./bulkUpload/bulk_icon.svg": 948,
	"./bulkUpload/cancel_icon.svg": 949,
	"./bulkUpload/failed_icon.svg": 950,
	"./bulkUpload/point_icon.svg": 951,
	"./bulkUpload/status_title_icon.svg": 952,
	"./bulkUpload/success_icon.svg": 953,
	"./bulkUpload/upload_icon.svg": 954,
	"./calender.svg": 955,
	"./cart/Ellipse 2112.svg": 956,
	"./cart/Group 134.png": 957,
	"./cart/Group 7244.png": 958,
	"./cart/Group 7553.png": 959,
	"./cart/Group 9056.png": 960,
	"./cart/Homepage/Account Statment.png": 961,
	"./cart/Homepage/App Store.png": 962,
	"./cart/Homepage/Blog-1.png": 963,
	"./cart/Homepage/Blog-2.png": 964,
	"./cart/Homepage/Blog-3.png": 965,
	"./cart/Homepage/Blog-4.png": 966,
	"./cart/Homepage/Blogs.png": 967,
	"./cart/Homepage/Business Portfolio.png": 968,
	"./cart/Homepage/Car-Big.png": 969,
	"./cart/Homepage/Car-inner.png": 970,
	"./cart/Homepage/Downloads.png": 971,
	"./cart/Homepage/Education-Big.png": 972,
	"./cart/Homepage/Education-inner.png": 973,
	"./cart/Homepage/Equity-man.png": 974,
	"./cart/Homepage/Facebook.png": 975,
	"./cart/Homepage/Footer Arrow.png": 976,
	"./cart/Homepage/Group Sites.png": 977,
	"./cart/Homepage/Holiday-Big.png": 978,
	"./cart/Homepage/Holiday-inner.png": 979,
	"./cart/Homepage/House-Big.png": 980,
	"./cart/Homepage/House-Inner.png": 981,
	"./cart/Homepage/Investment-Background.png": 982,
	"./cart/Homepage/Logo.png": 983,
	"./cart/Homepage/Main-blog.png": 984,
	"./cart/Homepage/Map.png": 985,
	"./cart/Homepage/Money Plant.png": 986,
	"./cart/Homepage/Motilal Building.svg": 987,
	"./cart/Homepage/Multiple-girl.png": 988,
	"./cart/Homepage/NAV.png": 989,
	"./cart/Homepage/Newsletter Logo.png": 990,
	"./cart/Homepage/Next-trillion.png": 991,
	"./cart/Homepage/PiggyBank.png": 992,
	"./cart/Homepage/Play man.png": 993,
	"./cart/Homepage/Playstore Logo.png": 994,
	"./cart/Homepage/Plus-Icon.png": 995,
	"./cart/Homepage/Rectangle 4132.png": 996,
	"./cart/Homepage/Rectangle 4293.png": 997,
	"./cart/Homepage/TAX.png": 998,
	"./cart/Homepage/Tools.png": 999,
	"./cart/Homepage/Top Arrow.png": 1000,
	"./cart/Homepage/Top Button Arrow.png": 1001,
	"./cart/Homepage/Twitter.png": 1002,
	"./cart/Homepage/Value Strategy.png": 1003,
	"./cart/Homepage/Wedding-Big.png": 1004,
	"./cart/Homepage/Wedding-inner.png": 1005,
	"./cart/Homepage/Whatsapp Logo.png": 1006,
	"./cart/Homepage/Youtube.png": 1007,
	"./cart/Homepage/adult-banking-blur-1.png": 1008,
	"./cart/Homepage/apple.png": 1009,
	"./cart/Homepage/building.png": 1010,
	"./cart/Homepage/cancel.png": 1011,
	"./cart/Homepage/cart.png": 1012,
	"./cart/Homepage/common-application-icon.svg": 1013,
	"./cart/Homepage/compare-icon.svg": 1014,
	"./cart/Homepage/compare-portfolio-default 1.png": 1015,
	"./cart/Homepage/compare-portfolio-default.png": 1016,
	"./cart/Homepage/compare-portfolio.png": 1017,
	"./cart/Homepage/compounding-magic-default.png": 1018,
	"./cart/Homepage/compounding-magic.png": 1019,
	"./cart/Homepage/documents-icons.zip": 1020,
	"./cart/Homepage/factsheet-icon.svg": 1021,
	"./cart/Homepage/fundcard-bg.svg": 1022,
	"./cart/Homepage/fundsize-icon.svg": 1023,
	"./cart/Homepage/goal-calculator-default.png": 1024,
	"./cart/Homepage/goal-calculator.png": 1025,
	"./cart/Homepage/info-icon.svg": 1026,
	"./cart/Homepage/investor logo.png": 1027,
	"./cart/Homepage/key-man.svg": 1028,
	"./cart/Homepage/leaflte-icon.svg": 1029,
	"./cart/Homepage/mail.png": 1030,
	"./cart/Homepage/minamt-icon.svg": 1031,
	"./cart/Homepage/piggyBG.svg": 1032,
	"./cart/Homepage/playstore.png": 1033,
	"./cart/Homepage/presentation-icon.svg": 1034,
	"./cart/Homepage/return-icon.svg": 1035,
	"./cart/Homepage/right-arrow.png": 1036,
	"./cart/Homepage/risk-icon.svg": 1037,
	"./cart/Homepage/risk-veryhigh.png": 1038,
	"./cart/Homepage/search.png": 1039,
	"./cart/Homepage/share-icon.png": 1040,
	"./cart/Homepage/sip-calculator-default.png": 1041,
	"./cart/Homepage/sip-calculator.png": 1042,
	"./cart/Homepage/smartphone.png": 1043,
	"./cart/Homepage/taxBG.svg": 1044,
	"./cart/Homepage/undraw_super_woman_dv0y.png": 1045,
	"./cart/Homepage/user.png": 1046,
	"./cart/Homepage/whatsapp.png": 1047,
	"./cart/Money Flag.png": 1048,
	"./cart/Rectangle 3362.png": 1049,
	"./cart/Shake Hand.png": 1050,
	"./cart/addAcc.svg": 1051,
	"./cart/arrowleft.png": 1052,
	"./cart/bob.png": 1053,
	"./cart/c1.png": 1054,
	"./cart/calendar_icon.svg": 1055,
	"./cart/card-sip-icon.svg": 1056,
	"./cart/card_lumpsum_icon.svg": 1057,
	"./cart/cart_dnf.svg": 1058,
	"./cart/close_icon.svg": 1059,
	"./cart/distributor_profile.png": 1060,
	"./cart/e1.svg": 1061,
	"./cart/e2.svg": 1062,
	"./cart/e3.svg": 1063,
	"./cart/e4.svg": 1064,
	"./cart/f1.png": 1065,
	"./cart/faq.svg": 1066,
	"./cart/female-icon.png": 1067,
	"./cart/fofBG.svg": 1068,
	"./cart/fofIcon.svg": 1069,
	"./cart/greenRight.svg": 1070,
	"./cart/holding_icon.svg": 1071,
	"./cart/hourse.svg": 1072,
	"./cart/investment/Group 8534.jpg": 1073,
	"./cart/investment/Group 8534@2x.jpg": 1074,
	"./cart/investment/calender.svg": 1075,
	"./cart/investment/female.svg": 1076,
	"./cart/investment/leftBG.svg": 1077,
	"./cart/investment/leftbg.jpg": 1078,
	"./cart/investment/lumsum.svg": 1079,
	"./cart/investment/male.svg": 1080,
	"./cart/investment/red.svg": 1081,
	"./cart/investment/rightbg.svg": 1082,
	"./cart/investment/sip.svg": 1083,
	"./cart/investment/switch.svg": 1084,
	"./cart/investment/upload.svg": 1085,
	"./cart/key1.jpg": 1086,
	"./cart/key2.jpg": 1087,
	"./cart/key3.jpg": 1088,
	"./cart/keyimg.jpg": 1089,
	"./cart/lock.svg": 1090,
	"./cart/loginpeople.svg": 1091,
	"./cart/m1.png": 1092,
	"./cart/m2.png": 1093,
	"./cart/male-icon.png": 1094,
	"./cart/media.jpg": 1095,
	"./cart/mens.png": 1096,
	"./cart/mens.svg": 1097,
	"./cart/mfDetailbg.svg": 1098,
	"./cart/mftimeline.svg": 1099,
	"./cart/mgBG.svg": 1100,
	"./cart/minus_icon.svg": 1101,
	"./cart/noun_locked lock_1010538.svg": 1102,
	"./cart/overview1.png": 1103,
	"./cart/p1.png": 1104,
	"./cart/playicon.svg": 1105,
	"./cart/plus_icon.svg": 1106,
	"./cart/popup_side_img.svg": 1107,
	"./cart/postlogin/authentication-icon.svg": 1108,
	"./cart/postlogin/bank-icon.svg": 1109,
	"./cart/postlogin/bitcoin.svg": 1110,
	"./cart/postlogin/boost-btn-icon.png": 1111,
	"./cart/postlogin/broker-error-icon.svg": 1112,
	"./cart/postlogin/broker-icon.svg": 1113,
	"./cart/postlogin/broker-success-icon.svg": 1114,
	"./cart/postlogin/call-icon.svg": 1115,
	"./cart/postlogin/cancel (2).svg": 1116,
	"./cart/postlogin/card-add-to-cart-icon.svg": 1117,
	"./cart/postlogin/card-lumpsum-icon.svg": 1118,
	"./cart/postlogin/card-sip-icon.svg": 1119,
	"./cart/postlogin/cart-icon.svg": 1120,
	"./cart/postlogin/carttable-infoicon.svg": 1121,
	"./cart/postlogin/cashflow-checkout-icon.svg": 1122,
	"./cart/postlogin/cheque-icon.svg": 1123,
	"./cart/postlogin/delete-icon.svg": 1124,
	"./cart/postlogin/direct-ribbon.svg": 1125,
	"./cart/postlogin/edit-icon.svg": 1126,
	"./cart/postlogin/elss-fund.gif": 1127,
	"./cart/postlogin/email-icon.svg": 1128,
	"./cart/postlogin/error-table-icon.svg": 1129,
	"./cart/postlogin/exit-load-icon.svg": 1130,
	"./cart/postlogin/facebook-logo.svg": 1131,
	"./cart/postlogin/filter-icon.svg": 1132,
	"./cart/postlogin/folio-icon.svg": 1133,
	"./cart/postlogin/folio-joint.svg": 1134,
	"./cart/postlogin/folio-minor.svg": 1135,
	"./cart/postlogin/folio-single.svg": 1136,
	"./cart/postlogin/footer-blue-bg.svg": 1137,
	"./cart/postlogin/footer-chatwithus-icon.svg": 1138,
	"./cart/postlogin/footer-faqs-icon.svg": 1139,
	"./cart/postlogin/footer-searchlocation-icon.svg": 1140,
	"./cart/postlogin/footer-whatsapp-icon.svg": 1141,
	"./cart/postlogin/greenarrow-icon.svg": 1142,
	"./cart/postlogin/greentick-icon.svg": 1143,
	"./cart/postlogin/grid-icon.svg": 1144,
	"./cart/postlogin/index-funds.gif": 1145,
	"./cart/postlogin/info-icon.svg": 1146,
	"./cart/postlogin/infobig-icon.svg": 1147,
	"./cart/postlogin/instagram-logo.svg": 1148,
	"./cart/postlogin/internationalBG.jpg": 1149,
	"./cart/postlogin/list-icon.svg": 1150,
	"./cart/postlogin/loader-logo.svg": 1151,
	"./cart/postlogin/main-clip.svg": 1152,
	"./cart/postlogin/mandate-homepage-banner.jpg": 1153,
	"./cart/postlogin/mandate-icon.svg": 1154,
	"./cart/postlogin/mastercard-icon.svg": 1155,
	"./cart/postlogin/money-bag.svg": 1156,
	"./cart/postlogin/more-vertical.svg": 1157,
	"./cart/postlogin/multiasset-balancing-mob-banner.jpg": 1158,
	"./cart/postlogin/neft-rtgs-icon.svg": 1159,
	"./cart/postlogin/neftrtgs-icon.svg": 1160,
	"./cart/postlogin/net-banking-icon.svg": 1161,
	"./cart/postlogin/netbanking-otm-icon.svg": 1162,
	"./cart/postlogin/order-icon.svg": 1163,
	"./cart/postlogin/otm-mandate-mob.jpg": 1164,
	"./cart/postlogin/payment-fail.svg": 1165,
	"./cart/postlogin/payment-method-icon.svg": 1166,
	"./cart/postlogin/payment-success.svg": 1167,
	"./cart/postlogin/payment-summary-icon.svg": 1168,
	"./cart/postlogin/payment-waiting.svg": 1169,
	"./cart/postlogin/pms-homepage-mob-banner.jpg": 1170,
	"./cart/postlogin/profit.svg": 1171,
	"./cart/postlogin/redamount-icon.svg": 1172,
	"./cart/postlogin/redarrow-icon.svg": 1173,
	"./cart/postlogin/redemption-icon.svg": 1174,
	"./cart/postlogin/regular-ribbon.svg": 1175,
	"./cart/postlogin/review-checkout-icon.svg": 1176,
	"./cart/postlogin/rupee-sign.svg": 1177,
	"./cart/postlogin/schedule-sip-icon.svg": 1178,
	"./cart/postlogin/search-icon.svg": 1179,
	"./cart/postlogin/sip-error-icon.svg": 1180,
	"./cart/postlogin/sip-shubh-aarambh-mob-banner.jpg": 1181,
	"./cart/postlogin/sipmenu-bank.svg": 1182,
	"./cart/postlogin/sipmenu-cancel.svg": 1183,
	"./cart/postlogin/sipmenu-feedback.svg": 1184,
	"./cart/postlogin/sipmenu-pause.svg": 1185,
	"./cart/postlogin/sipmenu-statement.svg": 1186,
	"./cart/postlogin/small-clip.svg": 1187,
	"./cart/postlogin/stp-icon.svg": 1188,
	"./cart/postlogin/swp-icon.svg": 1189,
	"./cart/postlogin/tax-icon.svg": 1190,
	"./cart/postlogin/thank-you.png": 1191,
	"./cart/postlogin/twitter-logo.svg": 1192,
	"./cart/postlogin/upi-icon.svg": 1193,
	"./cart/postlogin/whatsapp-banner.jpg": 1194,
	"./cart/postlogin/x-circle.svg": 1195,
	"./cart/postlogin/youtube-logo.svg": 1196,
	"./cart/rightCheck.svg": 1197,
	"./cart/rightarrow.svg": 1198,
	"./cart/rupeesBg.svg": 1199,
	"./cart/rupeesIcon.svg": 1200,
	"./cart/sbi.png": 1201,
	"./cart/searchbar.svg": 1202,
	"./cart/share2.png": 1203,
	"./cart/sip_info_icon.svg": 1204,
	"./cart/tagmsg.svg": 1205,
	"./cart/taxBG.svg": 1206,
	"./cart/taxIcon.svg": 1207,
	"./cart/transgender-icon.png": 1208,
	"./cart/v1.svg": 1209,
	"./cart/v2.svg": 1210,
	"./cart/v3.svg": 1211,
	"./cart/v4.svg": 1212,
	"./cart/v5.svg": 1213,
	"./cart/v6.svg": 1214,
	"./cart/v7.svg": 1215,
	"./cart/yellowcolor.png": 1216,
	"./cart/yellowcolor2x.png": 1217,
	"./category/addedcart-icon.svg": 1218,
	"./category/addtocart-icon.svg": 1219,
	"./category/calendar_icon.svg": 1220,
	"./category/card-lumpsum-icon.svg": 1221,
	"./category/card-sip-icon.svg": 1222,
	"./category/curved-arrow-right.svg": 1223,
	"./category/curved-arrow.svg": 1224,
	"./category/fundcard-bg.svg": 1225,
	"./category/fundsize-icon.svg": 1226,
	"./category/grid-icon.svg": 1227,
	"./category/info-icon.svg": 1228,
	"./category/list-icon.svg": 1229,
	"./category/minamt-icon.svg": 1230,
	"./category/qb_cancel_icon.svg": 1231,
	"./category/qb_mod_icon.svg": 1232,
	"./category/qb_remove_item.svg": 1233,
	"./category/return-icon.svg": 1234,
	"./category/risk-icon.svg": 1235,
	"./category/risk-veryhigh.png": 1236,
	"./category/search-icon.svg": 1237,
	"./category/shopping-bag.svg": 1238,
	"./cfile.svg": 666,
	"./chart1.svg": 1239,
	"./clientlist/additional_purchase_icon.svg": 1240,
	"./clientlist/bar.svg": 1241,
	"./clientlist/clientslist-icon.svg": 1242,
	"./clientlist/coin-light.svg": 1243,
	"./clientlist/coin.svg": 1244,
	"./clientlist/createfolio_icon.svg": 1245,
	"./clientlist/dashboard-light.svg": 1246,
	"./clientlist/dashboard.svg": 1247,
	"./clientlist/error-light.svg": 1248,
	"./clientlist/error.svg": 1249,
	"./clientlist/folio-icon.svg": 1250,
	"./clientlist/folio-light.svg": 1251,
	"./clientlist/icon_fab.png": 1252,
	"./clientlist/isip_icon.svg": 1253,
	"./clientlist/kyc-light.svg": 1254,
	"./clientlist/kyc.svg": 1255,
	"./clientlist/minus.svg": 1256,
	"./clientlist/nctEditIcon.svg": 1257,
	"./clientlist/nfo_icon.svg": 1258,
	"./clientlist/nfo_title_icon.svg": 1259,
	"./clientlist/plus.svg": 1260,
	"./clientlist/redeem_icon.svg": 1261,
	"./clientlist/stp_icon.svg": 1262,
	"./clientlist/switch_icon.svg": 1263,
	"./clientlist/swp_icon.svg": 1264,
	"./contact/Map.png": 1265,
	"./contact/building.svg": 1266,
	"./contact/building_icon.png": 1267,
	"./contact/mail.png": 1268,
	"./contact/smartphone.png": 1269,
	"./contact/user.png": 1270,
	"./copy-clipboard.svg": 629,
	"./dash/404_error.svg": 1271,
	"./dash/accountstmt.svg": 1272,
	"./dash/annualreturn.png": 1273,
	"./dash/banner.svg": 1274,
	"./dash/bar.svg": 1275,
	"./dash/buymore.svg": 1276,
	"./dash/calVec.svg": 1277,
	"./dash/client-icon.png": 1278,
	"./dash/coin-light.svg": 1279,
	"./dash/coin.svg": 1280,
	"./dash/currentvalue.png": 1281,
	"./dash/dailygain.png": 1282,
	"./dash/dash.svg": 1283,
	"./dash/green.svg": 1284,
	"./dash/gross-sale-icon.png": 1285,
	"./dash/investment.png": 1286,
	"./dash/latestActive.svg": 1287,
	"./dash/minus.svg": 1288,
	"./dash/orderbook.svg": 1289,
	"./dash/plus.svg": 1290,
	"./dash/portfolio-dnf-icon.svg": 1291,
	"./dash/portfolioview.png": 1292,
	"./dash/red.svg": 1293,
	"./dash/redem.svg": 1294,
	"./dash/redemption-icon.png": 1295,
	"./dash/revenue-icon.png": 1296,
	"./dash/scheduletrans.svg": 1297,
	"./dash/sipUp.svg": 1298,
	"./dash/total-aum-icon.png": 1299,
	"./dash/totalInvestment.png": 1300,
	"./dash/totalgain.png": 1301,
	"./dash/transhis.svg": 1302,
	"./dash/upcomming.svg": 1303,
	"./dash/zbp_folio_creation_icon.svg": 1304,
	"./dash/zbp_make_payment_icon.svg": 1305,
	"./dash/zbp_select_fund_icon.svg": 1306,
	"./dash/zero_balance_portfolio.svg": 1307,
	"./dash/zero_balance_steps_icon.svg": 1308,
	"./dit_home/distributor-banner-bg.jpg": 1309,
	"./dit_home/distributor-feat-1-hover.png": 1310,
	"./dit_home/distributor-feat-1.png": 1311,
	"./dit_home/distributor-feat-2-hover.png": 1312,
	"./dit_home/distributor-feat-2.png": 1313,
	"./dit_home/distributor-feat-3-hover.png": 1314,
	"./dit_home/distributor-feat-3.png": 1315,
	"./dit_home/distributor-feat-4-hover.png": 1316,
	"./dit_home/distributor-feat-4.png": 1317,
	"./dit_home/distributor-graphic2.png": 1318,
	"./dit_home/graphic2.png": 1319,
	"./dit_home/mo-parteners-digi-connect-l.png": 1320,
	"./dit_home/mo-parteners-digi-connect-l1.png": 1321,
	"./dit_home/wave-static-01.svg": 1322,
	"./dit_home/wave-static-02.svg": 1323,
	"./ditdash/Factsheet.svg": 1324,
	"./ditdash/IFA.svg": 1325,
	"./ditdash/activeSIP.svg": 1326,
	"./ditdash/alarm-reminder.svg": 1327,
	"./ditdash/annualreport.svg": 1328,
	"./ditdash/applicationform.svg": 1329,
	"./ditdash/bulb.svg": 1330,
	"./ditdash/cash.svg": 1331,
	"./ditdash/commission_icon.svg": 1332,
	"./ditdash/failed-icon.svg": 630,
	"./ditdash/icon_annualreturn.png": 1333,
	"./ditdash/icon_totalgain.png": 1334,
	"./ditdash/info.svg": 1335,
	"./ditdash/invest_cart_icon.svg": 1336,
	"./ditdash/invest_transfer_icon.svg": 1337,
	"./ditdash/latestadd_icon.svg": 1338,
	"./ditdash/leaflet.svg": 1339,
	"./ditdash/manage-icon.png": 1340,
	"./ditdash/notice_icon.svg": 1341,
	"./ditdash/orderbook.svg": 1342,
	"./ditdash/pre.svg": 1343,
	"./ditdash/profile-setting.svg": 1344,
	"./ditdash/read.svg": 1345,
	"./ditdash/rmperformance_icon.svg": 1346,
	"./ditdash/rupees-icon-setting.svg": 1347,
	"./ditdash/success-tick.svg": 631,
	"./ditdash/totalbvstotalifa_graph.svg": 1348,
	"./ditdash/transactionssnap_icon.svg": 1349,
	"./ditdash/upSIP.svg": 1350,
	"./ditdash/webinar-banner.svg": 1351,
	"./download/Edit.svg": 1352,
	"./download/banner.svg": 1353,
	"./download/close.svg": 1354,
	"./download/cloud.svg": 1355,
	"./download/email.svg": 1356,
	"./download/pdf.png": 1357,
	"./download/view.svg": 1358,
	"./download/whatsapp.svg": 1359,
	"./download/xls.png": 1360,
	"./email.svg": 667,
	"./eye.svg": 1361,
	"./fab-background.png": 1362,
	"./fab-logo.png": 1363,
	"./fabPlan/MO_fab_plan.png": 1364,
	"./fabPlan/calImagePopUp.png": 1365,
	"./fabPlan/calImagePopUp2X.png": 1366,
	"./fabPlan/fab-background.png": 1367,
	"./fabPlan/fab-logo.png": 1368,
	"./fabPlan/fab-logo@2x.png": 1369,
	"./fabPlan/gold.png": 1370,
	"./fabPlan/idea_fab_plan.png": 1371,
	"./fabPlan/info-icon.svg": 668,
	"./fabPlan/info-icon2.svg": 1372,
	"./fabPlan/info-icon3.svg": 1373,
	"./fabPlan/loading.svg": 1374,
	"./fabPlan/order-summary-icon.svg": 1375,
	"./fabPlan/pencil.svg": 1376,
	"./fabPlan/recommended-icon.png": 1377,
	"./fabPlan/ribbon-strip.png": 1378,
	"./fabPlan/small-calendar-2.svg": 1379,
	"./fabPlan/small-calendar.svg": 1380,
	"./fabPlan/statistics.png": 1381,
	"./fabPlan/tablet-active.png": 1382,
	"./fabPlan/thankyou-page-banner.svg": 1383,
	"./fabPlan/thumbs-up.png": 1384,
	"./faq/faq.svg": 1385,
	"./faq/searchbar.svg": 1386,
	"./footer/arrow_down_thin.png": 1387,
	"./footer/arrow_up_filled.png": 1388,
	"./footer/call.png": 1389,
	"./footer/mail.png": 1390,
	"./footer/whatsapp.png": 1391,
	"./fundIcon/MHR.svg": 1392,
	"./fundIcon/fofBG.svg": 1393,
	"./fundIcon/fofIcon.svg": 1394,
	"./fundIcon/growth_icon.svg": 1395,
	"./fundIcon/growth_icon1.svg": 1396,
	"./fundIcon/growth_icon3.svg": 1397,
	"./fundIcon/rupeesBg.svg": 1398,
	"./fundIcon/rupeesIcon.svg": 1399,
	"./fundIcon/taxBG.svg": 1400,
	"./fundIcon/taxIcon.svg": 1401,
	"./greenRight.svg": 1402,
	"./header/appstore_mobile_black.png": 1403,
	"./header/arrow_down_thin.png": 1404,
	"./header/arrow_down_thin.svg": 1405,
	"./header/arrow_right.png": 1406,
	"./header/become-distributor_new.svg": 1407,
	"./header/close.png": 1408,
	"./header/commodity.svg": 1409,
	"./header/debt_and_liquid.svg": 1410,
	"./header/downloads_new.svg": 1411,
	"./header/dropdown-arrow.svg": 1412,
	"./header/etf.svg": 1413,
	"./header/face/face2.jpg": 1414,
	"./header/face/face28.png": 1415,
	"./header/face/face3.jpg": 1416,
	"./header/face/face4.jpg": 1417,
	"./header/faq_new.svg": 1418,
	"./header/fund_icon.png": 1419,
	"./header/hybrid_and_balanced.svg": 1420,
	"./header/index_fund.svg": 1421,
	"./header/indian_equity.svg": 1422,
	"./header/international_equity.svg": 1423,
	"./header/login_new.svg": 1424,
	"./header/logo-dark.svg": 1425,
	"./header/logo-mini.svg": 1426,
	"./header/logo.svg": 1427,
	"./header/mobile_menu.png": 1428,
	"./header/multi_asset.svg": 1429,
	"./header/nfo_beacon.gif": 1430,
	"./header/phone.png": 1431,
	"./header/phone_red.png": 1432,
	"./header/playstore_mobile_black.png": 1433,
	"./header/quick_purchase_new.svg": 1434,
	"./header/wand.png": 632,
	"./header/why_choose_us_new.svg": 1435,
	"./home/Blog-1.png": 1436,
	"./home/Blog-2.png": 1437,
	"./home/Blog-3.png": 1438,
	"./home/Blog-4.png": 1439,
	"./home/Equity-man.png": 1440,
	"./home/Investment-Background.png": 1441,
	"./home/Main-blog.png": 1442,
	"./home/Multiple-girl.png": 1443,
	"./home/Playman.png": 1444,
	"./home/account_statement.png": 1445,
	"./home/apple.png": 1446,
	"./home/banner1.svg": 1447,
	"./home/blog.png": 1448,
	"./home/download.png": 1449,
	"./home/investorlogo.png": 1450,
	"./home/key-man.svg": 1451,
	"./home/nav.png": 1452,
	"./home/playstore.png": 1453,
	"./home/ques.png": 1454,
	"./home/smartmockups_jzwdpybx.png": 1455,
	"./home/tools.png": 1456,
	"./home/whatsapp.png": 1457,
	"./info.png": 1458,
	"./international/internationalBG.jpg": 1459,
	"./international/key1.png": 1460,
	"./international/key2.png": 1461,
	"./international/key3.png": 1462,
	"./international/mens.jpg": 1463,
	"./international/tag.png": 1464,
	"./intersetialBigImg.svg": 1465,
	"./investment/Group 8534.jpg": 1466,
	"./investment/Group 8534@2x.jpg": 1467,
	"./investment/boost-btn-icon.png": 1468,
	"./investment/calender.svg": 1469,
	"./investment/female.svg": 1470,
	"./investment/filter-icon.svg": 1471,
	"./investment/leftBG.svg": 1472,
	"./investment/leftbg.jpg": 1473,
	"./investment/lumsum.svg": 1474,
	"./investment/male.svg": 1475,
	"./investment/order-icon.svg": 1476,
	"./investment/red.svg": 1477,
	"./investment/rightbg.svg": 1478,
	"./investment/schedule-sip-icon.svg": 1479,
	"./investment/sip-boosted.png": 1480,
	"./investment/sip.svg": 1481,
	"./investment/sipmenu-bank.svg": 1482,
	"./investment/sipmenu-cancel.svg": 1483,
	"./investment/sipmenu-feedback.svg": 1484,
	"./investment/sipmenu-pause.svg": 1485,
	"./investment/sipmenu-statement.svg": 1486,
	"./investment/small-clip.svg": 1487,
	"./investment/switch.svg": 1488,
	"./investment/upload.svg": 1489,
	"./investment/x-circle.svg": 1490,
	"./isip.svg": 1491,
	"./kyc/thank-you.png": 1492,
	"./landing/MHR.svg": 1493,
	"./landing/PMS-BG.svg": 1494,
	"./landing/diverse-portfolio-w.png": 1495,
	"./landing/fofBG.svg": 1496,
	"./landing/fofIcon.svg": 1497,
	"./landing/growth_icon.svg": 1498,
	"./landing/growth_icon1.svg": 1499,
	"./landing/growth_icon3.svg": 1500,
	"./landing/hourse.svg": 1501,
	"./landing/key1.jpg": 1502,
	"./landing/key2.jpg": 1503,
	"./landing/key3.jpg": 1504,
	"./landing/keyimg.jpg": 1505,
	"./landing/m1.png": 1506,
	"./landing/m2.png": 1507,
	"./landing/m3.png": 1508,
	"./landing/m4.png": 1509,
	"./landing/m5.png": 1510,
	"./landing/mgBG.svg": 1511,
	"./landing/p1.png": 1512,
	"./landing/p2.png": 1513,
	"./landing/p3.png": 1514,
	"./landing/p4.png": 1515,
	"./landing/p5.png": 1516,
	"./landing/passBGbottom.svg": 1517,
	"./landing/playicon.svg": 1518,
	"./landing/pms1.png": 1519,
	"./landing/pms2.png": 1520,
	"./landing/pms3.png": 1521,
	"./landing/pms4.png": 1522,
	"./landing/professional-management-w.png": 1523,
	"./landing/rightarrow.svg": 1524,
	"./landing/rupeesBg.svg": 1525,
	"./landing/rupeesIcon.svg": 1526,
	"./landing/safe-transperent-w.png": 1527,
	"./landing/tax-saving-w.png": 1528,
	"./landing/taxBG.svg": 1529,
	"./landing/taxIcon.svg": 1530,
	"./leftBG.svg": 1531,
	"./leftbg.jpg": 1532,
	"./listing/Mask Group 31.svg": 1533,
	"./listing/P_M_R.svg": 1534,
	"./listing/Rectangle 4184.svg": 1535,
	"./listing/bg_pms.svg": 1536,
	"./listing/charttest.svg": 1537,
	"./listing/d.png": 1538,
	"./listing/db_small.png": 1539,
	"./listing/e1.svg": 1540,
	"./listing/e2.svg": 1541,
	"./listing/e3.svg": 1542,
	"./listing/e4.svg": 1543,
	"./listing/investmentp.svg": 1544,
	"./listing/l1.png": 1545,
	"./listing/lt.png": 1546,
	"./listing/mens.png": 1547,
	"./listing/mens.svg": 1548,
	"./listing/mfDetailbg.svg": 1549,
	"./listing/p1.png": 1550,
	"./listing/p2.png": 1551,
	"./listing/p_icon1.svg": 1552,
	"./listing/pms-startegy-banner.png": 1553,
	"./listing/pmsBG.svg": 1554,
	"./listing/pms_v1.png": 1555,
	"./listing/pms_v10.png": 1556,
	"./listing/pms_v2.png": 1557,
	"./listing/pms_v3.png": 1558,
	"./listing/pms_v4.png": 1559,
	"./listing/pms_v5.png": 1560,
	"./listing/pms_v6.png": 1561,
	"./listing/pms_v7.png": 1562,
	"./listing/pms_v8.png": 1563,
	"./listing/pms_v9.png": 1564,
	"./listing/pmsbottom.svg": 1565,
	"./listing/po.png": 1566,
	"./listing/portolifo_left.svg": 1567,
	"./listing/portolifo_right.svg": 1568,
	"./listing/r1.png": 1569,
	"./listing/r_small.png": 1570,
	"./listing/red_pdf.svg": 1571,
	"./listing/tr.png": 1572,
	"./listing/v1.svg": 1573,
	"./listing/v10.svg": 1574,
	"./listing/v11.svg": 1575,
	"./listing/v12.svg": 1576,
	"./listing/v13.svg": 1577,
	"./listing/v14.svg": 1578,
	"./listing/v2.svg": 1579,
	"./listing/v3.svg": 1580,
	"./listing/v4.svg": 1581,
	"./listing/v5.svg": 1582,
	"./listing/v6.svg": 1583,
	"./listing/v7.svg": 1584,
	"./listing/v9.svg": 1585,
	"./listing/why1.png": 1586,
	"./listing/why2.png": 1587,
	"./listing/why3.png": 1588,
	"./listing/why4.png": 1589,
	"./lock.svg": 1590,
	"./login-image.png": 669,
	"./login/Authentic_successful 1.png": 1591,
	"./login/CFFundPasscodeImage.gif": 1592,
	"./login/DITLoginLeft.png": 1593,
	"./login/Large-Cap-Fund-passcode-banner.jpg": 1594,
	"./login/NFO-login-left.jpg": 1595,
	"./login/NFO_passcode_banner.jpg": 1596,
	"./login/OrangeLine.png": 1597,
	"./login/Web-popup-Banner.jpg": 1598,
	"./login/Website-Blogs-Banner-closing-340X340.jpg": 1599,
	"./login/Website-passcode-Banner-new-340X340.jpg": 1600,
	"./login/accountlocked 1.png": 1601,
	"./login/advertise.png": 1602,
	"./login/arbitrage-fund-passcode.jpg": 1603,
	"./login/bagIcon.png": 1604,
	"./login/bse-1000-fund-passcode-banner.jpg": 1605,
	"./login/cancel_icon.png": 1606,
	"./login/check_icon.png": 1607,
	"./login/checked.png": 670,
	"./login/city_icon.png": 1608,
	"./login/ditLoginLeftImage.png": 1609,
	"./login/ditLoginLeftImage1.5.png": 1610,
	"./login/ditLoginLeftImage2.png": 1611,
	"./login/dit_login.png": 1612,
	"./login/download_icon.png": 1613,
	"./login/email.svg": 1614,
	"./login/email_icon.png": 1615,
	"./login/financial-fund-passcode-340x340.gif": 1616,
	"./login/grow_more.png": 1617,
	"./login/grow_more_label_line.png": 1618,
	"./login/icon-productupdate.png": 1619,
	"./login/infrastructure-fund-passcode.gif": 1620,
	"./login/kyc_verify_icon.png": 1621,
	"./login/latest_update.png": 1622,
	"./login/mobile_icon.png": 1623,
	"./login/multi-factor-passcode-340x340.gif": 1624,
	"./login/nifty-capital-market.jpg": 1625,
	"./login/pan_icon.png": 1626,
	"./login/pan_name_icon.png": 1627,
	"./login/password_hide.svg": 1628,
	"./login/password_icon.png": 1629,
	"./login/pms_invetstment.png": 1630,
	"./login/share_1.png": 1631,
	"./login/showPassword.svg": 1632,
	"./login/show_password_icon.png": 1633,
	"./login/show_password_icon_old.svg": 1634,
	"./login/transcendGrowthImage.jpg": 1635,
	"./login/view_icon.png": 1636,
	"./login/whatsapp.svg": 1637,
	"./loginpeople.svg": 1638,
	"./logo-dit.png": 1639,
	"./logo-mo-amc.png": 624,
	"./logo-mo-amc2.png": 625,
	"./logo.svg": 1640,
	"./manageBank/icon_bank.svg": 1641,
	"./manageBank/notestyle.png": 1642,
	"./manageBank/success.svg": 1643,
	"./minus.png": 1644,
	"./nav/Group 253.svg": 1645,
	"./nav/MO_Asset_Management_Logo.webp": 1646,
	"./nav/MO_icon.webp": 1647,
	"./nav/aldemat_navicon-light.svg": 1648,
	"./nav/aldemat_navicon.svg": 1649,
	"./nav/amc_Partners_logo.svg": 1650,
	"./nav/cart.svg": 1651,
	"./nav/dashboard-bulk-transaction-icon-light.svg": 1652,
	"./nav/dashboard-bulk-transaction-icon.svg": 1653,
	"./nav/dashboard-initiated-history-icon.svg": 1654,
	"./nav/dashboard-investor-list-icon-light.svg": 1655,
	"./nav/dashboard-investor-list-icon.svg": 1656,
	"./nav/dashboard-new-folio-icon-light.svg": 1657,
	"./nav/dashboard-new-folio-icon.svg": 1658,
	"./nav/dashboard-quick-invest-icon-light.svg": 1659,
	"./nav/dashboard-quick-invest-icon.svg": 1660,
	"./nav/dashboard-report-icon.svg": 1661,
	"./nav/feedback-icon-light.png": 1662,
	"./nav/feedback-icon.png": 1663,
	"./nav/goalbase_navicon-light.svg": 1664,
	"./nav/goalbase_navicon.svg": 1665,
	"./nav/ic_arrow-circle-left.svg": 1666,
	"./nav/ic_arrow-circle-right.svg": 1667,
	"./nav/invest_navicon-light.svg": 1668,
	"./nav/invest_navicon.svg": 1669,
	"./nav/manageac_navicon-light.svg": 1670,
	"./nav/manageac_navicon.svg": 1671,
	"./nav/managepr_navicon-light.svg": 1672,
	"./nav/managepr_navicon.svg": 1673,
	"./nav/manual-icon-light.png": 1674,
	"./nav/manual-icon.png": 1675,
	"./nav/mastercart-icon.png": 1676,
	"./nav/menu.png": 1677,
	"./nav/mf-amc-brst-logo.png": 1678,
	"./nav/mf-m-min-logo.svg": 1679,
	"./nav/mnschedule_navicon-light.svg": 1680,
	"./nav/mnschedule_navicon.svg": 1681,
	"./nav/moamc-logo-new.png": 1682,
	"./nav/moamc-mf-logo-new.png": 1683,
	"./nav/myportfolio_navicon-light.svg": 1684,
	"./nav/myportfolio_navicon.svg": 1685,
	"./nav/navBanner.svg": 1686,
	"./nav/orderbook_navicon-light.svg": 1687,
	"./nav/orderbook_navicon.svg": 1688,
	"./nav/profile-icon.png": 1689,
	"./nav/redemption_navicon-light.svg": 1690,
	"./nav/redemption_navicon.svg": 1691,
	"./nav/report_navicon-light.svg": 1692,
	"./nav/report_navicon.svg": 1693,
	"./nav/smartplan_navicon-light.svg": 1694,
	"./nav/smartplan_navicon.svg": 1695,
	"./nav/transfer_navicon-light.svg": 1696,
	"./nav/transfer_navicon.svg": 1697,
	"./onboarding/bg_craft.png": 1698,
	"./onboarding/female-icon.png": 1699,
	"./onboarding/male-icon.png": 1700,
	"./onboarding/nomineeFamilyIcon.svg": 1701,
	"./onboarding/transgender-icon.png": 1702,
	"./option_icon.png": 1703,
	"./payment/info-icon.svg": 1704,
	"./payment/mastercard-icon.svg": 1705,
	"./payment/neft-rtgs-icon.svg": 1706,
	"./payment/net-banking-icon.svg": 1707,
	"./payment/payment-method-icon.svg": 1708,
	"./payment/upi-icon.svg": 1709,
	"./plusicon.png": 1710,
	"./pms/BusinessPortfolio.png": 1711,
	"./pms/DedicatedRMs.png": 1712,
	"./pms/EqualityPortfolioGirl.svg": 1713,
	"./pms/IndiaOpportunityV1.png": 1714,
	"./pms/IndiaOpportunityV2.png": 1715,
	"./pms/Linkedinlogo.png": 1716,
	"./pms/Next-trillion.png": 1717,
	"./pms/PMS-Tree.svg": 1718,
	"./pms/PerformanceChart.png": 1719,
	"./pms/RaamdeoAggarwal.png": 1720,
	"./pms/RequestDeskGirl.svg": 1721,
	"./pms/RightWave.png": 1722,
	"./pms/Segregatedportfolios.png": 1723,
	"./pms/Telephone.png": 1724,
	"./pms/Transparency.png": 1725,
	"./pms/ValueStrategy.png": 1726,
	"./pms/pdf_download_icon.png": 671,
	"./pms/xls_download_icon.png": 1727,
	"./prelogin-header/Logo.png": 1728,
	"./prelogin-header/basket-banner.gif": 1729,
	"./prelogin-header/cashflow-img.svg": 1730,
	"./prelogin-header/login-icon.svg": 1731,
	"./prelogin-header/login-lock.svg": 1732,
	"./prelogin-header/logo-mo-asset.png": 1733,
	"./prelogin-header/moamc-logo-new.png": 1734,
	"./prelogin-header/moamc-logo.png": 1735,
	"./prelogin-header/movi-img.svg": 1736,
	"./prelogin-header/quick-invest-icon.svg": 1737,
	"./profile/ach_icon.png": 1738,
	"./profile/addprofile.svg": 1739,
	"./profile/bill_icon.png": 1740,
	"./profile/contact_icon.png": 1741,
	"./profile/euinlist.png": 1742,
	"./profile/fatca2_icon.png": 1743,
	"./profile/folio-icon.svg": 1744,
	"./profile/mandate_icon.png": 1745,
	"./profile/minus.png": 1746,
	"./profile/netbankg_icon.png": 1747,
	"./profile/nominee_icon.png": 1748,
	"./profile/plus.png": 1749,
	"./profile/profile_pic.png": 1750,
	"./profile/user_icon.png": 1751,
	"./reedem.svg": 1752,
	"./rightarrow.svg": 1753,
	"./rightbg.svg": 1754,
	"./searchicon.png": 1755,
	"./share-icon.png": 1756,
	"./sip.svg": 1757,
	"./stp.svg": 1758,
	"./switch.svg": 1759,
	"./swp.svg": 1760,
	"./tnc/Plus.png": 1761,
	"./tnc/contact.jpg": 1762,
	"./tnc/contactUs.jpg": 1763,
	"./tnc/contactus-banner2.jpg": 1764,
	"./tnc/disclaimer.jpg": 1765,
	"./tnc/minus.png": 1766,
	"./tnc/sitemap-banner.jpg": 1767,
	"./tnc/terms.jpg": 1768,
	"./tnc/yellowcolor.png": 1769,
	"./tools.svg": 1770,
	"./tools/Car-Big.png": 1771,
	"./tools/Car-inner.png": 1772,
	"./tools/Education-Big.png": 1773,
	"./tools/Education-inner.png": 1774,
	"./tools/Holiday-Big.png": 1775,
	"./tools/Holiday-inner.png": 1776,
	"./tools/House-Big.png": 1777,
	"./tools/House-Inner.png": 1778,
	"./tools/Money Plant.png": 1779,
	"./tools/Wedding-Big.png": 1780,
	"./tools/Wedding-inner.png": 1781,
	"./tools/compare-portfolio-default.png": 1782,
	"./tools/compare-portfolio.png": 1783,
	"./tools/compounding-magic-default.png": 1784,
	"./tools/compounding-magic.png": 1785,
	"./tools/goal-calculator-default.png": 1786,
	"./tools/goal-calculator.png": 1787,
	"./tools/sip-calculator-default.png": 1788,
	"./tools/sip-calculator.png": 1789,
	"./trackorder/calender.svg": 1790,
	"./trackorder/filter-icon.svg": 1791,
	"./trackorder/order-icon.svg": 1792,
	"./trackorder/order_book_dfn.svg": 1793,
	"./trackorder/small-clip.svg": 1794,
	"./trans/Group 8999.png": 1795,
	"./trans/Group 9000.png": 1796,
	"./trans/Rectangle 4355.png": 1797,
	"./trans/Rectangle 4356.png": 1798,
	"./trans/Vector Smart Object.svg": 1799,
	"./trans/addmoney.png": 1800,
	"./trans/authentication-icon.svg": 1801,
	"./trans/bank-icon.svg": 1802,
	"./trans/boost-icon.png": 1803,
	"./trans/broker-icon.svg": 1804,
	"./trans/cart-icon.svg": 1805,
	"./trans/cashflow_icon.svg": 1806,
	"./trans/dematFolioPopupIcon.svg": 1807,
	"./trans/exit-load-icon.svg": 1808,
	"./trans/folio-icon.svg": 1809,
	"./trans/greenarrow-icon.svg": 1810,
	"./trans/hanger.png": 1811,
	"./trans/icon-accept.svg": 1812,
	"./trans/info-icon.svg": 1813,
	"./trans/infobig-icon.svg": 1814,
	"./trans/invest-fund-icon.svg": 1815,
	"./trans/isip-icon.svg": 1816,
	"./trans/isip.png": 1817,
	"./trans/main-clip.svg": 1818,
	"./trans/minus-icon.svg": 1819,
	"./trans/new-fund-icon.svg": 1820,
	"./trans/new-fund-side-img-old.svg": 1821,
	"./trans/new-fund-side-img.svg": 1822,
	"./trans/pigybank-old.png": 1823,
	"./trans/pigybank.png": 1824,
	"./trans/plus-icon.svg": 1825,
	"./trans/redamount-icon.svg": 1826,
	"./trans/redemption-icon.svg": 1827,
	"./trans/redemtionthank.png": 1828,
	"./trans/sip-img.svg": 1829,
	"./trans/small-clip.svg": 1830,
	"./trans/stp-icon.svg": 1831,
	"./trans/swp-icon.svg": 1832,
	"./trans/swp-img.svg": 1833,
	"./trans/tax-icon.svg": 1834,
	"./transResponse/elss-fund.gif": 1835,
	"./transResponse/index-funds.gif": 1836,
	"./transResponse/mandate-homepage-banner.jpg": 1837,
	"./transResponse/order-icon.svg": 1838,
	"./transResponse/otm-mandate-mob.jpg": 1839,
	"./transResponse/payment-fail.svg": 1840,
	"./transResponse/payment-success.svg": 1841,
	"./transResponse/payment-waiting.svg": 1842,
	"./transResponse/pending-consent-icon.png": 1843,
	"./transResponse/pending-consent-icon.svg": 1844,
	"./transResponse/whatsapp-banner old.jpg": 1845,
	"./transResponse/whatsapp-banner.jpg": 1846,
	"./transactionStatus/fail_icon.svg": 1847,
	"./transactionStatus/success_icon.svg": 1848,
	"./tri.png": 1849,
	"./user.png": 672,
	"./whatsapp-icon.gif": 1850,
	"./whatsapp.svg": 673,
	"./whatsapp_banner_headline_desktop.gif": 1851,
	"./whatsapp_banner_headline_desktop_blue.gif": 1852,
	"./whatsapp_banner_headline_desktop_new.gif": 1853,
	"./whatsapp_banner_headline_mobile.gif": 1854,
	"./whatsapp_banner_headline_mobile_blue.gif": 1855,
	"./whatsapp_banner_headline_mobile_new.gif": 1856,
	"./whatsapp_blinking_icon_new.gif": 1857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;